import React from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { formatShortDate } from '../../../helpers/dateHelpers';
import { applyComponentTheme } from '../../../theme';
import { GridItem } from '../../Grid';
import { AuthorName, GridWithMargins, Heading, PageInfo, Subhead } from './styles';

export type HeroPlainProps = {
  heading: string;
  subhead?: string;
  author?: string;
  date?: Date;
  readTime?: number;
  useColoredHeading?: boolean;
  hideAuthorPrefix?: boolean;
} & ComponentProps;

/** Banner with text, and no background */
const HeroPlain: React.FC<HeroPlainProps> = ({
  heading,
  subhead,
  author,
  date,
  readTime,
  useColoredHeading,
  hideAuthorPrefix,
  ...props
}) => (
  <GridWithMargins alignLeft {...componentProps(props)}>
    <GridItem desktop={10} tabletLandscape={10}>
      <div tabIndex={0}>
        <Heading useColoredHeading={useColoredHeading}>{heading}</Heading>
        {subhead && <Subhead>{subhead}</Subhead>}
      </div>
      {(author || date || readTime !== undefined) && (
        <PageInfo tabIndex={0}>
          {author && (
            <li>
              {hideAuthorPrefix ? '' : 'By '}
              <AuthorName>{author}</AuthorName>
            </li>
          )}
          {date && <li>{formatShortDate(date, true)}</li>}
          {readTime !== undefined && <li>Read time: {readTime} mins</li>}
        </PageInfo>
      )}
    </GridItem>
  </GridWithMargins>
);

export default applyComponentTheme(HeroPlain, 'HeroPlain');
